var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!!_vm.day)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.content,
    trigger: 'hover click',
  }),expression:"{\n    content: content,\n    trigger: 'hover click',\n  }"}],staticClass:"TourDate",on:{"click":function($event){return _vm.tourDayClicked()}}},[_vm._v(" "+_vm._s(_vm.startDayMonth)+" "),_c('div',{staticClass:"TourDate__number"},[_vm._v(_vm._s(_vm.startDayNumber))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }